export type DashboardTab = 'orders' | 'address';

export type AdminTab = 'orders' | 'users' | 'warehouses';

interface CopyField {
  label?: string;
  value: string;
}

export interface CopyProps {
  field: CopyField;
}

export enum OrderStatus {
  PENDING = 'PENDING',
  AT_WAREHOUSE = 'AT_WAREHOUSE',
  PACKED = 'PACKED',
  SENT_TO_DESTINATION = 'SENT_TO_DESTINATION',
  DELIVERED = 'DELIVERED',
}

export enum Currency {
  KGS = 'KGS',
  USD = 'USD',
}

export interface Amount {
  amount: number;
  currency: Currency;
}

export interface Location {
  lat?: number;
  lon?: number;
  address?: string;
}

export interface Store {
  name?: string;
}

export interface User {
  id: string;
  email?: string;
  firstName?: string;
  lastName?: string;
}

export interface Order {
  id: string;
  amount: Amount;
  createdDate: number;
  deliveryAddress?: Location;
  name: string;
  parcelCount: number;
  status: OrderStatus;
  store?: Store;
  trackingNumber: string;
  updatedDate: number;
  user: User;
  warehouseId?: string;
  statusUpdatedDate?: number;
}
